<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <h2 ref="tituloRef" class="mesa-titulo animate-item">
      MESA DE<br />REGALOS
    </h2>

    <p ref="descripcionRef" class="mesa-descripcion animate-item">
      Nuestro mejor regalo es compartir este día con ustedes. <br>
      Pero si desean tener una muestra de cariño con nosotros, les dejamos las siguientes sugerencias.
    </p>

    <button @click="mostrarOverlay" class="btn-mesa animate-item">
      VER OPCIONES
    </button>

    <transition name="fade">
      <div v-if="overlayVisible" class="overlay" @click.self="cerrarOverlay">
        <div class="overlay-content" role="dialog" aria-modal="true" aria-label="Opciones de regalo">
          <h3 class="overlay-title">Opciones de regalo</h3>

          <!-- Tarjeta 1: Sobre -->
          <div class="mesa-tarjeta">
            <img src="@/assets/SOBRE.avif" alt="Ícono de sobre" class="icono-sobre" />
            <p class="mesa-lugar">Sobrecito de Amor</p>
            <p class="mesa-numero">Pueden encontrar un sobre y un buzón en la recepción.</p>
          </div>

          <div class="linea-divisoria"></div>

          <!-- Tarjeta 2: Depósito bancario -->
          <div class="mesa-tarjeta">
            <p class="mesa-lugar">Adriana Elizabeth Rosas Agraz</p>
            <p class="mesa-numero banco">SANTANDER</p>

            <div class="dato-copiable">
              <p class="mesa-numero"><strong>CLABE:</strong> 0143 2060 5340 8152 59</p>
            </div>

            <div class="dato-copiable">
              <p class="mesa-numero"><strong>No. Cuenta:</strong> 5579 0701 1569 6224</p>
            </div>
          </div>

          <div class="linea-divisoria"></div>

          <!-- Tarjeta 3: Mesa de Regalos Liverpool -->
          <div class="mesa-tarjeta liverpool">
            <p class="mesa-lugar">Mesa de Regalos Liverpool</p>
            <p class="mesa-numero">
              Número de lista: <strong>51771371</strong>
            </p>

            <a
              class="btn-liverpool"
              href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/51771371"
              target="_blank"
              rel="noopener"
              aria-label="Abrir Mesa de Regalos Liverpool en una nueva pestaña"
            >
              Ir a la lista en Liverpool
            </a>
          </div>

          <div class="linea-divisoria"></div>

          <!-- Tarjeta 4: Mesa de Regalos Amazon -->
          <div class="mesa-tarjeta amazon">
            <p class="mesa-lugar">Mesa de Regalos Amazon</p>
            <a
              class="btn-liverpool"
              href="https://www.amazon.com.mx/wedding/share/Bodaelyyaldo"
              target="_blank"
              rel="noopener"
              aria-label="Abrir Mesa de Regalos Amazon en nueva pestaña"
            >
              Ir a la lista en Amazon
            </a>
          </div>

          <button @click="cerrarOverlay" class="btn-cerrar">Regresar a la invitación</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)
    const overlayVisible = ref(false)
    const elementosAnimados = ref([])

    const mostrarOverlay = () => {
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    const copiarTexto = async (texto) => {
      try {
        await navigator.clipboard.writeText(texto)
        alert('¡Copiado al portapapeles!')
      } catch (e) {
        console.error(e)
        alert('No se pudo copiar. Inténtalo de nuevo.')
      }
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value = regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(elementosAnimados.value).indexOf(entry.target)
                gsap.fromTo(
                  entry.target,
                  { opacity: 0, y: 40, scale: 0.95 },
                  {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.8,
                    delay: index * 0.15,
                    ease: 'power2.out',
                  }
                )
                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        elementosAnimados.value.forEach((el) => observer.observe(el))
      })
    })

    return {
      regalosRef,
      overlayVisible,
      mostrarOverlay,
      cerrarOverlay,
      copiarTexto,
    }
  },
}
</script>

<style scoped>
.mesa-regalos-section {
  background-color: #f2eee8;
  color: #1a1a1a;
  font-family: 'Playfair Display', serif;
  text-align: center;
  padding: 60px 20px;
}

.mesa-titulo {
  font-size: 26px;
  font-weight: normal;
  line-height: 1.4;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #1a1a1a;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  color: #444;
  margin-bottom: 30px;
}

.btn-mesa {
  background: none;
  border: 1px solid #1a1a1a;
  padding: 8px 18px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}
.btn-mesa:hover { background: #1a1a1a; color: #fff; }

/* Overlay */
.overlay {
  position: fixed; inset: 0;
  background: rgba(26, 26, 26, 0.9);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}
.overlay-content {
  background: #f9f6f1;
  color: #1a1a1a;
  border-radius: 12px;
  padding: 30px 20px;
  max-width: 420px; width: 100%;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  margin: auto;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}
.overlay-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.mesa-tarjeta { margin-bottom: 20px; }
.mesa-lugar {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  margin-bottom: 6px;
}
.mesa-numero { font-size: 13px; letter-spacing: 0.5px; }
.mesa-numero.banco { letter-spacing: 1px; font-weight: 600; }

.dato-copiable {
  display: flex; align-items: center; gap: 8px;
  justify-content: center; margin-top: 6px;
}
.btn-copiar {
  border: 1px solid #1a1a1a;
  background: transparent;
  font-size: 11px;
  padding: 4px 10px;
  cursor: pointer;
  transition: .25s ease;
}
.btn-copiar:hover { background: #1a1a1a; color: #fff; }

.btn-cerrar {
  margin-top: 22px;
  background: none;
  border: 1px solid #1a1a1a;
  padding: 7px 16px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}
.btn-cerrar:hover { background: #1a1a1a; color: #fff; }

/* Línea divisoria */
.linea-divisoria {
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, transparent, #1a1a1a, transparent);
  margin: 26px auto;
}

/* Ícono del sobre */
.icono-sobre {
  width: 40px; height: 40px; object-fit: contain;
  margin-bottom: 10px;
  filter: invert(1) brightness(0.3);
}

/* Liverpool / Amazon */
.liverpool .mesa-lugar,
.amazon .mesa-lugar {
  font-size: 19px;
}
.btn-liverpool {
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #1a1a1a;
  padding: 8px 14px;
  font-size: 12px;
  text-transform: uppercase;
  background-color: #434242;
  text-decoration: none;
  color: #f0f0f0;
  transition: .25s ease;
}
.btn-liverpool:hover { background: #1a1a1a; color: #fff; }

.animate-item { opacity: 0; transform: translateY(40px); }

/* Transición overlay */
.fade-enter-active, .fade-leave-active { transition: opacity 0.4s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
